
  // Function to get the auth token from session storage
// Function to get the auth token from either localStorage or sessionStorage
const getAuthToken = () => {
  let token = localStorage.getItem('token') || sessionStorage.getItem('token');

  // Check if token is found in either storage
  if (!token) {
    console.error("❌ Auth token not found in localStorage or sessionStorage.");
    console.error("Available localStorage keys:", Object.keys(localStorage));
    console.error("Available sessionStorage keys:", Object.keys(sessionStorage));
    return null;
  }

  // Remove extra quotes if present
  token = token.replace(/^"(.*)"$/, '$1'); // Removes surrounding quotes if they exist

  console.log("✅ Auth token retrieved successfully, length:", token.length);
  return token;
};


// Function to set up headers
const getHeaders = () => {
  let token = getAuthToken();

  // If no token found, return empty headers or handle appropriately
  if (!token) {
    console.error("❌ No auth token available for request - API call will fail");
    return {
      headers: {}
    };
  }

  // Ensure 'Bearer' is not added twice
  if (!token.startsWith('Bearer ')) {
    token = `Bearer ${token}`;
  }

  console.log("✅ Headers prepared with Authorization token");
  return {
    headers: {
      Authorization: token,
    },
  };
};



  export {
getAuthToken,
getHeaders,

  }